/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ESPSettings} from './ESPSettings';

/**
 * The ESP model module.
 * @module model/ESP
 * @version 1.0.0
 */
export class ESP {
  /**
   * Constructs a new <code>ESP</code>.
   * @alias module:model/ESP
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ESP</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ESP} obj Optional instance to populate.
   * @return {module:model/ESP} The populated <code>ESP</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ESP();
      if (data.hasOwnProperty('_id'))
        obj._id = ApiClient.convertToType(data['_id'], 'String');
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('settings'))
        obj.settings = ESPSettings.constructFromObject(data['settings']);
      if (data.hasOwnProperty('created'))
        obj.created = ApiClient.convertToType(data['created'], 'String');
      if (data.hasOwnProperty('updated'))
        obj.updated = ApiClient.convertToType(data['updated'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} _id
 */
ESP.prototype._id = undefined;

/**
 * @member {String} title
 */
ESP.prototype.title = undefined;

/**
 * @member {String} description
 */
ESP.prototype.description = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
ESP.TypeEnum = {
  /**
   * value: "ses"
   * @const
   */
  ses: "ses"
};
/**
 * @member {module:model/ESP.TypeEnum} type
 */
ESP.prototype.type = undefined;

/**
 * @member {module:model/ESPSettings} settings
 */
ESP.prototype.settings = undefined;

/**
 * @member {String} created
 */
ESP.prototype.created = undefined;

/**
 * @member {String} updated
 */
ESP.prototype.updated = undefined;

